import { Movax } from './Movax';

var $ = require('jquery'),
    gmaps = require('./gmaps');

interface RecordData {
  countryCode: string
}

export module DealersApp {

  var app = {
    countryCode: null,
    coords: null,
    latLngPairs: [],
    rootUrl: '',
    dealerRedirectDoneName: 'dealer-redirect-done',
    dealerRedirectDoneExpire: (1000 * 60 * 60 * 3), // 3h
    //dealerRedirectDoneExpire: (1000 * 10), // 10s
    items: []
  };

  function getNearestDealer(countryCode, coords) {
    var i, l, foundItems = [], nearestIndex;

    // First by country code
    if (app.items) {
      for (i = 0, l = app.items.length; i < l; i++) {
        if(app.items[i].countryCode === countryCode) {
          foundItems.push(app.items[i]);
          //console.log('country found');
        }
      }
    }

    // If Found two items with same country, use nearest
    if(foundItems.length > 1) {
      //console.log('multiple dealers, find nearest');

      nearestIndex = Movax.geolocation.findNearest([coords.latitude, coords.longitude], foundItems);

      return foundItems[nearestIndex];
    } else if(foundItems.length === 1) {
      return foundItems[0];
    }

    return null;
  }

  function createLatLngPairs(itemData) {
    var i, l;
    for (i = 0, l = itemData.length; i < l; i++ ) {
      app.latLngPairs.push([+itemData[i].lat, +itemData[i].lng]);
    }
  }
  export function init(containerSelector: string, containerClass: string) {
    var $el = $(containerSelector),
      block = containerClass,
      jsBlock = 'js-' + block,
      $map,
      mapId = jsBlock + '__map',
      isDefaultView = false,
      currentDealer,
      $dealerSelect;

    if (!$el.length) {
      return;
    }

    $map = $el.find(containerSelector + '__map');

    app.items = $map.data('items');
    app.rootUrl = $el.data('root');
    currentDealer = $el.data('current');

    isDefaultView = $el.data('default-view');

    Movax.events.waitForWindowLoad().then(function() {
      // gmaps.dealersMap({
      //   'lat': $map.data('lat'),
      //   'lng': $map.data('lng'),
      //   'containerId': mapId,
      //   'infoHtml': $map.data('info-html'),
      //   'data': app.items,
      //   'fitAllMarkers': isDefaultView,
      //   'zoomToMarker': !isDefaultView ? app.items.filter(item => item.slug === currentDealer) : false
      // });
    });

    $dealerSelect = $el.find(containerSelector + '__dealer-select');
    $dealerSelect.on('change', function(e) {
      e.preventDefault();
      window.location = $dealerSelect.val();
    });

    // Only redirect anyway if storage is enabled so we can save redirect data and thus prevent redirect loop
    // And if this is the default view
    if (Movax.storage.isSessionStorageEnabled() && isDefaultView) {

      if (!Movax.storage.getSessionStorageItem(app.dealerRedirectDoneName)) {
        Promise.all([Movax.geolocation.getGeoIPRecord(), Movax.geolocation.getGeolocation()]).then(function(res) {
          var locationData = res[1], nearestDealer;
          var recordData: any = res[0];
          nearestDealer = getNearestDealer(recordData.countryCode, res[0] || res[1]);

          // Redirect to closest dealer
          if (nearestDealer) {
            Movax.storage.setSessionStorageItem(app.dealerRedirectDoneName, 'done', app.dealerRedirectDoneExpire);
            if (currentDealer !== nearestDealer.slug) {
              window.location.href = app.rootUrl + nearestDealer.slug + '/';
            }
          }
        });
      } else {

        // Already set, do nothing, we don't want to redirect more than once
      }
    }

  }
}
